import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoFaqWithImg, { EcoFaqWithImgItemProps } from 'eco-design/sections/eco-faq-win-img';
import styles from './index.module.scss';
import EfSection from '@elem/ui/ef-section';
import EfImg from '@elem/ui/ef-img';
import Modal2 from './Modal2';
import { useState } from 'react';
import { createPortal } from 'react-dom';

const JK: React.FC = () => {
    const { t } = useLang('delta_pro_ultra.launch.detail.PowerBackup2');
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const items: EcoFaqWithImgItemProps[] = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747902232808/Frame%201612707571.jpg',
            title: t('PowerBackup_item1_title'),
            desc: t('PowerBackup_item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747902233022/Frame%201612707572.jpg',
            title: t('PowerBackup_item2_title'),
            desc: t('PowerBackup_item2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747902233207/Frame%201612707573.jpg',
            title: t('PowerBackup_item3_title'),
            desc: t('PowerBackup_item3_desc'),
        },
    ];

    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EfSection title={t('PowerBackup_title')} desc={t('PowerBackup_desc')} />
            <EcoSpaceSmall />
            <EcoFaqWithImg items={items} />
            <button className={`btn`} onClick={() => setIsOpen(true)}>
                <span className="btn-text">{t('PowerBackup_btn')}</span>
                <EfImg className="btn-plus" pc="https://websiteoss.ecoflow.com/upload/image/1735629290398/add.svg" />
            </button>
            {isOpen && createPortal(<Modal2 type={isOpen} callback={() => setIsOpen(false)} />, document.body)}
            <EcoSpace />
        </div>
    );
};

export default JK;
